"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ApiService = /*#__PURE__*/function (_Service) {
  (0, _inherits2.default)(ApiService, _Service);
  function ApiService() {
    (0, _classCallCheck2.default)(this, ApiService);
    return _callSuper(this, ApiService, arguments);
  }
  (0, _createClass2.default)(ApiService, [{
    key: "getList",
    value: function getList(param) {
      return this.http.get("/admin/message_template/list?".concat(_qs.default.stringify(param)), param);
    }
  }, {
    key: "del",
    value: function del(param) {
      return this.http.get("/admin/message_template/delete?".concat(_qs.default.stringify(param)), param);
    }
  }, {
    key: "opera",
    value: function opera(param) {
      return this.http.post("/admin/message_template/add", param);
    }
  }]);
  return ApiService;
}(_serviceBase.default);
var _default = exports.default = new ApiService();